export default __webpack_public_path__ + "static/epilogue-170926305675335e4be15326cdd1d686.svg";